var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.file.processed)?_c('div',[_c('video',{attrs:{"controls":"","controlsList":"nodownload"}},[_c('source',{attrs:{"src":_vm._f("serverMediaFile")(_vm.file),"type":"video/mp4"}})])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }